import { render, staticRenderFns } from "./dataAuthority.vue?vue&type=template&id=5714a7a4"
import script from "./dataAuthority.vue?vue&type=script&lang=js"
export * from "./dataAuthority.vue?vue&type=script&lang=js"
import style0 from "./dataAuthority.vue?vue&type=style&index=0&id=5714a7a4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5714a7a4')) {
      api.createRecord('5714a7a4', component.options)
    } else {
      api.reload('5714a7a4', component.options)
    }
    module.hot.accept("./dataAuthority.vue?vue&type=template&id=5714a7a4", function () {
      api.rerender('5714a7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administrators/roleManage/dataAuthority.vue"
export default component.exports